import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState, useMemo } from 'react';
// import { useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
// import { footfallGraph } from 'api/sentinelAPI';
import { GetStoreGraph } from 'api';
import { useParams } from 'react-router';
// import Bubbledxaxis from './Bubbledx-axis';
// import {footfallGraph} from "api/sentinelAPI";
// const footfalldata=footfallGraph();

const CHART_COLORS = [
  '#10b981', // green
  '#06b6d4', // cyan
  '#9887fa', // purple
  '#f59e0b', // amber
  '#ef4444', // red
  '#8b5cf6', // violet
  '#ec4899', // pink
  '#14b8a6', // teal
  '#f97316', // orange
  '#84cc16', // lime
  '#3b82f6', // blue
  '#eab308', // yellow
  '#6366f1', // indigo
  '#f43f5e', // rose
  '#a21caf', // deep purple
  '#0ea5e9', // sky blue
  '#22d3ee', // light cyan
  '#fde68a', // light yellow
  '#fca5a5', // light red
  '#a7f3d0', // light green
  '#fcd34d', // gold
  '#c084fc'  // light violet
];

const Areachart = ({ dates }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [chartData, setChartData] = useState({
    dates: [],
    categories: {}
  });

  const { storeId } = useParams();

  // Process API data into chart format
  const processChartData = (data) => {
    if (!Array.isArray(data) || !data.length) return { dates: [], categories: {} };

    // Flatten the array of arrays
    const flatData = data.flat();

    // Get all unique dates (from timestamps)
    const datesSet = new Set(flatData.map(item => item.timestamps));
    const dates = Array.from(datesSet).sort();

    // Get all unique bay_ids
    const bayIds = [...new Set(flatData.map(item => item.bay_id))];

    // Initialize categories: { bay_id: [osa values by date] }
    const categories = {};
    bayIds.forEach(bay_id => {
      categories[bay_id] = dates.map(date => {
        // Find the entry for this bay_id and date
        const entry = flatData.find(item => item.bay_id === bay_id && item.timestamps === date);
        return entry && typeof entry.osa === 'number' ? entry.osa : 0;
      });
    });

    // Convert ISO dates to readable format for x-axis (optional)
    const formattedDates = dates.map(date => {
      const d = new Date(date);
      return d.toISOString().split('T')[0]; // 'YYYY-MM-DD'
    });

    return { dates: formattedDates, categories };
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!dates || !storeId) return;

      setLoading(true);
      setError(null);

      try {
        const response = await GetStoreGraph({
          date: dates,
          store_id: storeId
        });

        if (response?.data?.data) {
          const processedData = processChartData(response.data.data);
          setChartData(processedData);
        } else {
          setError('No data available');
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
        setError('Failed to load chart data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dates, storeId]);

  // useEffect(() => {
  //   async function getData2() {
  //     const body = {
  //       dates: dates,
  //       store_id: analysisStoreId
  //     };
  //     try {
  //       setLoading(true);
  //       const response = await GetSevenDaysOSA(body);
  //       const data = response.data;
  //       console.log('osa', data);
  //       setLoading(true);
  //       if (data) {
  //         const catagorydata = data.map((d) => d.date);
  //         const custdata = data.map((d) => parseFloat(d.averageFullness).toFixed(1));
  //         setOsa(custdata);
  //         setCategory(catagorydata);
  //         setLoading(false);
  //       }
  //       return data;
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }

  //   getData2();
  // }, [dates, analysisStoreId]);

  // useEffect(() => {
  //   async function getData() {
  //     const body = {
  //       dates: dates,
  //       store_id: analysisStoreId
  //     };
  //     try {
  //       setLoading(true);
  //       const response = await GetBayWiseVM(body);
  //       const data = response.data;
  //       console.log('vmmmm', data);
  //       setLoading(true);
  //       if (data) {
  //         console.log('entered data');
  //         const catagorydata = data.map((d) => d.date);
  //         const custdata = data.map((d) => parseFloat(d.avgVmScore).toFixed(1));
  //         setVM(custdata);
  //         setCategory(catagorydata);
  //         setLoading(false);
  //       }
  //       return data;
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }

  //   getData();
  // }, [dates, analysisStoreId]);
  //graph options start

  // Memoize series data to prevent unnecessary recalculations
  const series = useMemo(() => 
    Object.entries(chartData.categories).map(([category, data]) => ({
      name: category.charAt(0).toUpperCase() + category.slice(1),
      data: data
    })), [chartData.categories]);

  // Memoize chart options
  const chartOptions = useMemo(() => ({
    chart: {
      type: 'area',
      toolbar: { show: false },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: 2
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 90, 100]
      }
    },
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'center',
      floating: false,
      fontSize: '12px',
      fontFamily: 'Helvetica, Arial',
      fontWeight: 400,
      markers: {
        width: 12,
        height: 12,
        strokeWidth: 0,
        strokeColor: '#fff',
        radius: 12
      }
    },
    xaxis: {
      type: 'datetime',
      categories: chartData.dates,
      labels: {
        show: true,
        datetimeFormatter: {
          year: 'yyyy',
          month: "MMM 'yy",
          day: 'dd MMM',
          hour: 'HH:mm'
        }
      }
    },
    tooltip: {
      x: {
        format: 'dd MMM yyyy'
      },
      y: {
        formatter: (value) => `${value.toFixed(1)}%`
      }
    },
    yaxis: {
      type: 'numeric',
      min: 0,
      max: 100,
      labels: {
        formatter: (value) => `${value.toFixed(0)}%`
      }
    },
    colors: CHART_COLORS,
    grid: {
      borderColor: '#f1f1f1',
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    }
  }), [chartData.dates]);

  //graph options end

  // console.log(footfalldata);
  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="300px">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="300px">
        <CircularProgress />
      </Box>
    );
  }

  if (!chartData.dates.length) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="300px">
        <Typography>No data available</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <ReactApexChart 
        options={chartOptions} 
        series={series} 
        type="area" 
        width="100%" 
        height={400} 
      />
    </Box>
  );
};

export default Areachart;
